import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter } from '../../../../global/commonStyle';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  h1 {
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    gap: var(--space-24);
    margin-top: var(--space-8);
  `)}
`;

const Title = styled.div`
  color: var(--text-primary);
  ${Typography.heading_md}
`;
const BottomContent = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
`;

const Box = styled.div`
  ${FlexBetween}
  padding: var(--space-12) var(--space-16);
  gap: var(--space-12);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;

const LeftContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  h1 {
    color: var(--text-primary);
    ${Typography.body_lg_medium}
    margin: var(--space-0);
  }
`;
const Leftdata = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  max-width: 430px;
  h1 {
    color: var(--text-primary);
    ${Typography.heading_lg}
    margin: var(--space-0);
  }
  p {
    margin: var(--space-0);
    color: var(--text-secondary);
    ${Typography.body_md}
  }
`;
const RightContent = styled.div`
  white-space: nowrap;
  height: 24px;

  .background-image {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: var(--z-index-negative);
  }
`;

const Description = styled.div`
  ${AlignCenter}
  gap: var(--space-3);
  color: var(--text-secondary);
  p {
    color: var(--text-secondary);
    ${Typography.body_md}
    margin: var(--space-0);
  }
`;

const TopPlan = styled.div`
  display: flex;
  justify-content: space-between;
  padding: var(--space-16);
  gap: var(--space-16);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  position: relative;
  z-index: var(--z-index-base);
`;
const Row = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  p {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.body_md_medium}
  }
`;
const RowData = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  padding-block: var(--space-12) var(--space-18);
`;
const Price = styled.div`
  color: var(--brand-primary);
  text-align: center;
  ${Typography.heading_lg}
  span {
    color: var(--brand-primary);
    ${Typography.body_md_medium}
  }
`;

const Card = styled.div`
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-12);
  box-shadow: var(--shadow-card);
  padding: var(--space-24) var(--space-20) var(--space-20);
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-20);
`;
const Icon = styled.div`
  ${FlexCenter}

  &.three-dots {
    padding: var(--space-4);
    cursor: pointer;
    border-radius: var(--border-radius-4);
    &:hover {
      background: var(--neutral-secondary);
    }
    ${mobile_xl(css`
      padding: var(--space-6);
      svg {
        width: 20px;
        height: 20px;
      }
    `)}
  }
`;
const BottomDiv = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-8);
  h1 {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.heading_lg};
  }
  p {
    margin: var(--space-0);
    text-align: center;
    color: var(--text-secondary);
    ${Typography.body_lg};
  }
`;

export {
  Content,
  Title,
  BottomContent,
  Box,
  LeftContent,
  RightContent,
  Description,
  TopPlan,
  Row,
  RowData,
  Price,
  Leftdata,
  Card,
  Icon,
  BottomDiv
};
